<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
    
   export default {
      page: {
         title: "Prescriptions",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            title: "Prescriptions",
            items: [
               {
                  text: "Prescriptions",
                  active: true,
               },                   
            ],

            consultations: [],  
            doctors: [],         
            prescriptions: [],
            pagination: {},
            keyword: "",
            showsearch: false,
            listing_length: 10,
            consultation_status: "",
            doctor_id: "",
            token: "",
            errors: {},          
            active_page_url: null,
            from: null,
            to: null,
            total: null,
         };
      },
      mounted() {
    
      },

      created() {
         this.fetchPrescription();
         this.fetchDoctors();
      },
      methods: {


         fetchDoctors() {  
            let url = "clinic/clinicConsultedDoctors";         
            this.getToken();
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data;
                  console.log(responseData);
                  this.doctors = responseData.data;
               })
               .catch((err) => console.log(err));
         },


         fetchPrescription(page_url = null){

            this.getToken();
            let url = "clinic/prescriptions?keyword=" + this.keyword + "&limit=" + this.listing_length + "&doctor_id=" + this.doctor_id + "&status=" + this.consultation_status;

            page_url = page_url || url;

            if(localStorage.back_url) {
               page_url = localStorage.back_url;  
               localStorage.removeItem('back_url');
            }    

            this.active_page_url = page_url;
            this.loading = true;

            this.$axios
               .get(page_url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.prescriptions = responseData.bookings.data;


                  this.pagination = responseData.bookings.links;
                  this.from = responseData.bookings.from;
                  this.to = responseData.bookings.to;
                  this.total = responseData.bookings.total;
               
            })
            .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        if(typeof error.response.data.message === 'object') {
                           console.log(error.response.status);
                        } else {
                           this.$swal("", error.response.data.message, "error");
                        }                        
                        
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false));


         },

         getToken() {
            if (localStorage.getItem('medicino_clinic')) {
               var medicino_clinic =  JSON.parse(localStorage.getItem('medicino_clinic'));
               if(medicino_clinic.token) {
                  this.token = medicino_clinic.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         }, 


         showModal(modal) {
            this.$refs[modal].show();
         },

         hideModal(modal) {
            this.$refs[modal].hide();
         },
      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">
                  <!-- <h4 class="card-title"></h4>
                  <p class="card-title-desc"></p> -->

                  <!----- top button area starts---->
                  <!-- <div class="row mb-3">
                     <div class="col-12">
                        <router-link :to="{ name: 'consultations.add' }" class="btn btn-primary float-end">Add Consultation</router-link>
                     </div>
                  </div> -->
                  <!----- top button area ends---->

                  <!----- Listing length and search starts ----->
                  <div class="row mb-3">
                     <div class="col-sm-12 col-md-3">
                        <div class="listing-length" >
                           <label
                              >Show
                              <select class="form-control"  @change="fetchPrescription()" v-model="listing_length">
                                 <option value="5">5</option>
                                 <option value="10">10</option>
                                 <option value="15">15</option>
                              </select>
                              entries
                           </label>
                        </div>                        
                     </div>
                     <div class="col-sm-12 col-md-9">
                        <div class="listing-filter">
                           <label>
                              <input type="text" class="form-control" placeholder="Search" @keyup="fetchPrescription()" v-model="keyword"/>
                           </label>
                        </div>
                        <div class="listing-filter me-2">
                           <label>
                              <select class="form-control"  @change="fetchPrescription()" v-model="doctor_id">
                                 <option value="">All Doctors</option>
                                 <option :value="doctor.doctor_id" v-for="doctor in doctors" :key="doctor.doctor_id">{{doctor.name}}</option>
                           
                              </select>
                           </label>
                        </div>                      
                        <div class="listing-filter me-2">
                           <label>
                              <select class="form-control" @change="fetchPrescription()" v-model="consultation_status">
                                 <option value="">Today's Consultations</option>
                                 <option value="1">All Consultations</option>
                                 <!-- <option value="completed">Completed Consultations</option>
                                 <option value="completed">Cancelled Consultations</option> -->
                              </select>
                           </label>
                        </div>   
                     </div>
                  </div>
                  <!----- Listing length and search ends ----->

                  <!---- listing table starts -------->
                  <div class="table-responsive">
                     <table class="table table-bordered mb-0">
                        <thead class="table-light">
                           <tr>
                              <th width="15%">User</th>              
                              <th width="15%">Patient</th>              
                              <th width="15%">Doctor</th>   
                              <th width="25%">Booking Date & Slot, <br> Token</th>  
                              <th width="20%">Prescription</th>
                           </tr>
                        </thead>
                        <tbody v-if="Boolean(prescriptions.length)">
                           <tr v-for="(prescription) in prescriptions" :key="prescription.prescription_id">
                              <td v-if="prescription.member_name !=null">{{  prescription.member_name  }}<br>{{ prescription.country_code }} {{ prescription.mobile }}</td>                       
                              <td v-else>{{  prescription.patient_name  }}<br>{{ prescription.country_code }} {{  prescription.mobile  }}</td>                       
                              <td>
                                 {{  prescription.patient_name  }}
                              </td>
                              <td>Dr. {{ prescription.doctor_name }}</td>
                              <td>{{ prescription.booking_date|formatDate }}<br>{{ prescription.consultation_start|formatTime }} - {{ prescription.consultation_end|formatTime }}<br>{{ prescription.token }}</td>
                              <td v-if="prescription.prescription_url">
                                 <div class="file-wrapper">
                                    <a :href="$image_url + prescription.prescription_url" target="_blank">
                                       <img :src="$image_url + prescription.prescription_url" style="max-width: 100px;">
                                    </a>
                                 </div>
                              </td>
                           </tr>
                           
                        </tbody>
                        <tbody v-else>
                           <tr>
                              <td colspan="7" class="text-center">No prescriptions found</td>
                           </tr>
                        </tbody>
                     </table>
                  </div>
                  <!---- listing table ends -------->

                  <!----pagination starts --->     
                  <caption v-if="Boolean(prescriptions.length)" class="float-start mt-4 d-block d-lg-inline">Showing {{this.from}} to {{this.to}} of {{this.total}} entries</caption>               
                  <ul class="pagination pagination-rounded mt-4 float-lg-end d-md-inline-flex">
                     <li class="page-item "  v-bind:class="[{disabled: !page.url}, {active: page.active}]" v-for="(page, index) in pagination" :key="page.label">
                        <a href="#" class="page-link" @click.prevent="fetchPrescription(page.url + '&limit='+ listing_length + '&keyword=' + keyword  + '&doctor_id=' + doctor_id + '&status=' + consultation_status)">
                           <i v-if="index == 0" class="mdi mdi-chevron-left"></i>
                           <i v-else-if="index == pagination.length-1" class="mdi mdi-chevron-right"></i>
                           <span v-else>{{page.label}}</span>                          
                        </a>
                     </li>
                  </ul>
                  <!----pagination ends --->

                  <!---- modal starts ---->
                  <b-modal ref="cancel-modal" id="cancel-modal" title="Cancel Consultation" hide-footer>
                     <b-form>
                        
                        <b-col md="12" class="form-group">
                           <label class="control-label">Reason for Cancellation<span class="text-danger">*</span></label>
                           <textarea class="form-control" rows="4"></textarea>
                        </b-col>                      
                        
                        <b-col md="12">
                           <b-button type="button" class="me-3" variant="primary" @click="hideModal('cancel-modal')">Save</b-button>
                           <b-button class="" variant="light" @click="hideModal('cancel-modal')">Close</b-button>
                        </b-col>
                     </b-form>
                  </b-modal>
                  <!---- modal ends ----->

               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
